import React, { Component } from "react";

class Timer extends Component {
  constructor(props) {
    super(props);
    this.tic = this.tick.bind(this);
  }

  state = {
    elapsed: 0
  };

  getInitialState() {
    // This is called before our render function. The object that is
    // returned is assigned to this.state, so we can use it later.

    return { elapsed: 0 };
  }

  componentDidMount() {
    // componentDidMount is called by react when the component
    // has been rendered on the page. We can set the interval here:

    this.timer = setInterval(this.tick, 100);
  }

  componentWillUnmount() {
    // This method is called immediately before the component is removed
    // from the page and destroyed. We can clear the interval here:

    clearInterval(this.timer);
  }

  tick = () => {
    // This function is called every 50 ms. It updates the
    // elapsed counter. Calling setState causes the component to be re-rendered

    this.setState({
      elapsed: new Date() - this.props.start + this.props.penalizace * 1000
    });
  };

  styles = {
    fontSize: 20
  };

  render() {
    // Calculate elapsed to tenth of a second:
    var elapsed = Math.round(this.state.elapsed / 1000);
    var seconds = Math.round(elapsed % 60)
      .toString()
      .padStart(2, "0");
    var minutes = Math.floor(elapsed / 60);

    // This will give a number with one digit after the decimal dot (xx.x):
    //var seconds = (elapsed / 10).toString();
    // Although we return an entire <p> element, react will smartly update
    // only the changed parts, which contain the seconds variable.

    //console.log(this.props);

    return (
      <div style={this.styles} className="badge badge-info float-right m-2">
        <svg className="bi bi-stopwatch" width="1em" height="1em" viewBox="0 2 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" d="M8 15A6 6 0 108 3a6 6 0 000 12zm0 1A7 7 0 108 2a7 7 0 000 14z" clipRule="evenodd"/>
          <path fillRule="evenodd" d="M8 4.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H4.5a.5.5 0 010-1h3V5a.5.5 0 01.5-.5zM5.5.5A.5.5 0 016 0h4a.5.5 0 010 1H6a.5.5 0 01-.5-.5z" clipRule="evenodd"/>
          <path d="M7 1h2v2H7V1z"/>
        </svg>
        {minutes}:{seconds}
      </div>
    );
  }
}

export default Timer;
// ReactDOM.render(
//   <TimerExample start={Date.now()} />,
//   document.getElementById("container")
// );
